import { ReactNode } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { usePermissionsContext } from '../context/permissionsContext';

import { projectDetailRoutes, RESEARCH_HUB_PATH } from './navbar/constants';

/**
 * Apple suppliers only see three tabs (Figma 224:34447), so the pages behind
 * the hidden ones must not be reachable by typing the URL either. Allow-list
 * rather than block-list: a route added later is closed by default.
 */
const ALLOWED_PREFIXES = [
  '/supply-bridge',
  '/supply-link',
  '/credit-ratings',
  RESEARCH_HUB_PATH,
  '/pricing_and_supply',
  // Project detail tabs stay reachable; the out-of-plan ones render their own
  // locked state rather than 404ing.
  ...projectDetailRoutes,
  // Locked content links to these (research hub to /upgrade, the locked retiree
  // card to /contact). Product wants Apple to reach them to contact us.
  '/upgrade',
  '/contact',
];

export const isAppleAllowedPath = (pathname: string) =>
  pathname === '/' ||
  ALLOWED_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export const AppleRouteGate = ({ children }: { children: ReactNode }) => {
  const { isAppleClient } = usePermissionsContext();
  const { pathname } = useLocation();

  // Gate on an explicit true only: `client` is undefined while /user/me is in
  // flight, so a non-Apple user never sees a redirect flash.
  if (isAppleClient && !isAppleAllowedPath(pathname)) return <Navigate to='/' replace />;

  return <>{children}</>;
};
